import { render } from "./Invoice.vue?vue&type=template&id=00e8f093"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
script.render = render

export default script